import { Api } from '../../../api';
import { APP_USER_INFO } from '../../config/consts';
import { Browser } from '../../utils';
import { Settings } from '../../../config';

const { toLogin } = Browser;

/*
* 获取登录信息
* */
const getToken = () => window.localStorage.getItem(APP_USER_INFO);

/*
* 删除登录信息
* */
const delToken = () => {
  window.localStorage.removeItem(APP_USER_INFO);
};


function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role));
  }
  return true;
}

function hasPermissionByPoint(route, userPermissions) {
  if (route.meta && route.meta.permissions) {
    return userPermissions.some(premission => route.meta.permissions.includes(premission));
  }
  return true;
}

/*
* 路由过滤器
* */
const filterRoutes = (routes, roles) => {
  const res = [];
  routes.forEach(route => {
    if (hasPermission(roles, route)) {
      if (route.children) {
        route.children = filterRoutes(route.children, roles);
      }
      res.push(route);
    }
  });

  return res;
};

/**
 * @description 返回有权限的路由
 * @param {*} routes
 * @param {*} state
 */
const filterRoutesByPermissions = (routes, permissions) => {
  const res = [];
  routes.forEach(route => {
    if (hasPermissionByPoint(route, permissions)) {
      if (route.children) {
        route.children = filterRoutesByPermissions(route.children, permissions);
      }
      res.push(route);
    }
  });
  return res;
};

const getters = {
  roleId: state => state.info.role_id,
  isAdmin: state => state.info.role_id === 1
};

const mutations = {
  SET_USER_INFO: (state, info) => {
    state.info = info;
  },
  SET_ROUTES: (state, routes) => {
    state.routes = routes;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  }
};

const actions = {

  logout({ commit }) {
    return new Promise((resolve, reject) => {
      Api.User.goLogout().then(res => {
        if (res.code === 0) {
          delToken();
          toLogin(Settings.loginUrl);
          commit('CHANGE_USER', {});
          resolve();
        } else {
          reject(res);
        }
      }).catch(error => {
        reject(error);
      });
    });
  },

  resetToken({ commit }) {
    return new Promise(resolve => {
      delToken();
      commit('CHANGE_USER', {});
      resolve();
    });
  },

  getRoles({ commit, state }, info) {
    return new Promise(resolve => {
      commit('CHANGE_USER', info);
      const { role_id } = info;
      commit('SET_ROLES', [role_id]);
      resolve(state);
    });
  },

  setUserInfo({ commit }, info) {
    return new Promise(resolve => {
      commit('SET_USER_INFO', info);
      resolve(info);
    });
  },

  generateRoutes({ commit, state }, authRoutes) {
    return new Promise(resolve => {
      const addRoute = filterRoutes(authRoutes, state.roles);
      commit('SET_ROUTES', addRoute);
      resolve(addRoute || []);
    });
  },

  setRoutes({ commit, state }, appRoutes) {
    return new Promise(resolve => {
      const { info: { permission: permissions } } = state;
      const addRoute = filterRoutesByPermissions(appRoutes, permissions);
      commit('SET_ROUTES', addRoute);
      resolve(addRoute || []);
    });
  }

};

const state = {
  token: getToken(),
  info: {}, // 用户信息
  roles: null,
  routes: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
